import React from 'react'
import {connect} from "react-redux";
import FooterNav from "./FooterNav";

const Footer = () => {
    return (
        <footer className="footer black" role="contentinfo">
            <div className="wrap">
                <div className="row">
                    <article className="three-fourth">
                        <h6>About us</h6>
                        <p>Briz was built for a new generation of private ground transportation: refined, responsive,
                            and powered by intelligent technology without losing the human touch that defines true
                            white-glove service. Our goal is simple: to make premium car and limousine service feel
                            effortless from the first request to the destination. Briz combines experienced
                            transportation professionals, carefully selected chauffeurs, and AI-enabled service tools
                            designed to anticipate needs, improve communication, streamline bookings, and support
                            smoother customer experience. Under Briz, AI enhances the white-glove experience rather than
                            replacing it. The result is a transportation service that aims to be both highly intelligent
                            and deeply human. Simply put, Briz is not just about getting from one place to another. It
                            is about creating a better way to travel.</p>
                    </article>

                    <article className="one-fourth">
                        <h6>Need help?</h6>
                        <p>Contact us via email</p>
                        <p className="contact-data"><span className="icon icon-themeenergy_mail-2"/> <a
                            href="mailto:service@briz.com">service@briz.com</a></p>
                    </article>
                </div>

                <div className="copy">
                    <p>Copyright 2019, Briz Services. All rights reserved. </p>

                    <FooterNav/>
                </div>
            </div>
        </footer>
    )
};


const mapStateToProps = () => {
    return {};
};

export default React.memo(connect(mapStateToProps)(Footer));
